export const URLs = {
  base: '/bancochile-web/persona/eess/personas/rest',
  obtenerPreguntas: '/estado-situacion/valida/obtener-preguntas',
  validarCliente: '/estado-situacion/valida/rut',
  validarRespuestas: '/estado-situacion/valida/validar-respuestas',
  datosSolicitante:
    '/portabilidad-financiera-publico-rest/solicitud/consulta-solicitante',
  jwkRsa: '/estado-situacion/jwk/rsa',
  portalLogin: 'https://portalpersonas.bancochile.cl/persona',
  home: 'https://portales.bancochile.cl/personas'
};
